module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": "0.2rem 0 3rem 0"
    }
  }, [(_vm.formData.saiqu.is_jizan == 1) ? _c('van-form', {
    on: {
      "submit": _vm.onZanSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "value": _vm.formData.saiqu.name,
      "title": "赛区"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "value": _vm.formData.baoming.danwei,
      "title": "单位"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "value": _vm.formData.baoming.mingcheng,
      "title": "队伍名称"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "value": _vm.formData.subject_name,
      "title": "项目"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "点赞数",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入点赞数"
    },
    model: {
      value: (_vm.formData.jizan_count),
      callback: function($$v) {
        _vm.$set(_vm.formData, "jizan_count", $$v)
      },
      expression: "formData.jizan_count"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("请输入点赞数")]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "上传截图",
      "value": _vm.formData.jizan_pic.length + '/1'
    }
  }, [_c('template', {
    slot: "icon"
  }, [_c('van-icon', {
    staticClass: "question-icon",
    attrs: {
      "name": "question-o"
    },
    on: {
      "click": function($event) {
        return _vm.onQuestion('heying')
      }
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.jizan_pic,
      "limit": 1,
      "name": 'jizan_pic'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("请上传含有点赞数的截图")])], 1), _vm._v(" "), (_vm.canSubmit) ? _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": true,
      "loading": _vm.saveLoading,
      "loading-text": "已截止"
    }
  }, [_vm._v("已截止")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a748ebfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/zsai/SaiApplyFormUploadZan.vue
// module id = 2569
// module chunks = 0